<div class="item cn-up-down">
	<i class="icon">
		<answer-ico></answer-ico>
		<span class="counter"><span>{{ node._id_ + 1 }}</span></span>
	</i>
	<div class="name">Поднять трубку</div>
</div>
<div *ngIf="node != null && node.next != null" schema-node [node]="node.next"></div>